var map = {
	"./fx-breath.mp3": "fef2",
	"./fx-day.mp3": "1166",
	"./fx-evening.mp3": "5c9f",
	"./fx-morning.mp3": "7eb0",
	"./fx-night.mp3": "4792"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "297a";